export enum CUSTOM_EVENT_NAME {
  APPLY_FILTER = "apply_filter",
  GET_AB_TEST_LOADING = "get_ab_test_loading",
}
